import React from 'react';
import Dialog from '@mui/material/Dialog';
import { useTheme, useMediaQuery } from '@mui/material';

/**
 * ResponsiveDialog — thin wrapper over MUI Dialog.
 *
 * On phones (< md) the dialog goes full-screen, eliminating the cramped modal
 * feel and giving predictable keyboard behaviour when inputs are focused.
 * On tablet / desktop it behaves exactly like a normal MUI Dialog.
 *
 * All MUI Dialog props are forwarded as-is.
 *
 * Usage — just swap `Dialog` → `ResponsiveDialog`:
 *
 *   import ResponsiveDialog from '../../themes/components/ResponsiveDialog';
 *
 *   <ResponsiveDialog open={open} onClose={handleClose}>
 *     <DialogTitle>Create Invoice</DialogTitle>
 *     <DialogContent>...</DialogContent>
 *     <DialogActions>...</DialogActions>
 *   </ResponsiveDialog>
 */
export default function ResponsiveDialog({ children, ...props }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog fullScreen={fullScreen} {...props}>
      {children}
    </Dialog>
  );
}
